import { render, staticRenderFns } from "./TabRemark.vue?vue&type=template&id=07d2713f"
import script from "./TabRemark.vue?vue&type=script&lang=js"
export * from "./TabRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports